require('./aggregatorView.scss');

// @vendors
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
const { withRouter } = require('react-router-dom');

// @core
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @actions
import { getEntitiesData, getGlobalPositionTink } from 'actions/aggregator/aggregatorData.js';

// @components
import { OKHeaderSubPage } from 'commonsComponents/OKHeaderSubPage';
import { OKCover } from 'commonsComponents/OKCover';
import { OKButton } from 'commonsComponents/OKButton';
import { LoadingSection } from 'commonsComponents/loadingSection';
import TabbedBox from 'components/commons/tabbedBox/tabbedBox';
import TutorialLauncher from 'components/tutorial/tutorialLauncher';
import { OKHeaderSubPageDetails } from 'components/commons/OKHeaderSubPageDetails/OKHeaderSubPageDetails';
import { OKHeaderSubPageValue } from 'components/commons/OKHeaderSubPageValue/OKHeaderSubPageValue';
import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';
import { AggregatorSidebar } from 'components/aggregator/aggregatorSidebar/aggregatorSidebar';
import { CommercialAds } from 'components/commons/commercialAds/commercialAds';

// @utilities
import {
  getAggregatorBalanceBankByTypeProduct,
  getAggregatorBalanceBankByTypeProductTink,
} from 'selectors/aggregator';
import {
  recordLink,
  EVENT_ADD_MORE_ENTITY,
  PROC_ADD_ENTITY,
  PROC_START,
  PROC_AGGREGATOR,
} from 'utilities/tagging';
import { isAggregatorProductEnabled } from 'utilities/aggregator/aggregatorToggleHelper';
import { getTypeFromString, getStringFromType } from 'utilities/aggregator/aggregatorHelper';
import { formatAmountObject, getPlainAmountObject } from 'utilities/currencyHelper';

// @constants
import AggregatorProducts from 'constants/aggregator/products';
import { NOT_ALLOWED_TINK_AGGREGATOR } from 'constants/flagBasedFeatures';

const { GRAPHIC_TUTOR_TYPE_12 } = require('constants/index');

const language = getLanguage();

class AggregatorViewClass extends React.PureComponent {
  componentDidMount() {
    const { getEntitiesData, getGlobalPositionTink, hasBanks, isTinkAggregator } = this.props;

    if (!isTinkAggregator) {
      hasBanks.size === 0 && getEntitiesData();
    } else {
      !hasBanks && getGlobalPositionTink();
    }
  }

  handleChangeTab = index => {
    const { flagBasedFeatures, history } = this.props;

    const product = Object.values(AggregatorProducts).filter(p =>
      isAggregatorProductEnabled(flagBasedFeatures, p)
    )[index];
    recordLink(PROC_AGGREGATOR, product);
    history.push(`/myprofile/global/entities/${getStringFromType(product)}`);
  };

  handleAddNewEntity() {
    recordLink(PROC_ADD_ENTITY, PROC_START, EVENT_ADD_MORE_ENTITY);
    this.props.history.push('/myprofile/global/entities/add');
  }

  getMappingBreadcrumb() {
    return [
      {
        text: formatText('breadcrumb-global'),
        url: '/myprofile/global',
      },
      {
        text: formatText('breadcrumb-otherBanks'),
      },
    ];
  }

  getTab(k, p) {
    const value = p && p.get('balance') ? getPlainAmountObject(p.get('balance')) : null;

    return (
      <div>
        <div>
          <FormattedText value={`aggregatorTabs-${k}`} />
        </div>
        <div className="aggregator-view-tabs__amount">
          {value ? (
            <OneLineSymbolAmount
              amountObject={value}
              className="aggregator-view__details__amount"
              language={language}
              amountObjectFormatted={formatAmountObject(value, true)}
            />
          ) : (
            '-'
          )}
        </div>
      </div>
    );
  }

  getTabs = () => {
    const { immAggregatorData, flagBasedFeatures } = this.props;

    return Object.values(AggregatorProducts)
      .filter(p => isAggregatorProductEnabled(flagBasedFeatures, p))
      .map(tab => ({ label: this.getTab(tab, immAggregatorData.get(tab)) }));
  };

  getActiveProductTypeIndexFromUrl = () => {
    const { productType, flagBasedFeatures } = this.props;

    return Object.values(AggregatorProducts)
      .filter(p => isAggregatorProductEnabled(flagBasedFeatures, p))
      .findIndex(s => productType == s);
  };

  renderHeader = () => {
    const { aggregatorSavingAndInvestment, aggregatorFinancing } = this.props;

    return (
      <OKHeaderSubPageDetails>
        <OKHeaderSubPageValue
          textKey="aggregator-savingAndInvestment"
          value={aggregatorSavingAndInvestment}
          isAmountType={true}
          inverted={true}
        />
        <OKHeaderSubPageValue
          textKey="aggregator-financing"
          value={aggregatorFinancing}
          isAmountType={true}
          inverted={true}
        />
        <div className="aggregator-view__details__section__button">
          <OKButton modifier="ghost" inverse={true} onClick={() => this.handleAddNewEntity()}>
            <FormattedText value="aggregator-addEntityButton" />
          </OKButton>
        </div>
      </OKHeaderSubPageDetails>
    );
  };

  render() {
    const {
      children,
      immAggregatorData,
      productType,
      aggregatorSidebar,
      isFetching,
      hasBanks,
      flagBasedFeatures,
      aggregatorDataTink,
      isTinkAggregator,
    } = this.props;

    const activeTab = this.getActiveProductTypeIndexFromUrl();
    const tabs = this.getTabs();

    const tutorial = (
      <TutorialLauncher
        type={GRAPHIC_TUTOR_TYPE_12}
        title={formatText('tutorials-aggregatorViewTitle')}
        subtitle={formatText('tutorials-aggregatorViewSubtitle')}
        tooltip={formatText('tutorials-aggregatorViewTooltip')}
      />
    );

    const aggSidebarTotal = !isTinkAggregator
      ? immAggregatorData.get(productType)
      : aggregatorDataTink.aggregation[productType] &&
        aggregatorDataTink.aggregation[productType].balance;

    return (
      <div className="aggregator-view">
        <div className="container-fluid">
          <div className="row">
            <OKCover size="medium" section="accounts" customClass="col-xs-12">
              <OKHeaderSubPage
                breadcrumbConfig={this.getMappingBreadcrumb()}
                finalTitle={formatText('aggregator-headerTitle')}
                tutorial={tutorial}
                overlap={false}
              >
                {this.renderHeader()}
              </OKHeaderSubPage>
              {(immAggregatorData || aggregatorDataTink) && (
                <TabbedBox
                  onlyTabs={true}
                  onTabSelection={this.handleChangeTab}
                  activeTab={activeTab}
                  id="aggregatorTabs"
                  animated={true}
                  left={true}
                  tabs={tabs}
                  customClassName="aggregator-view__tabs"
                  withBorder={false}
                />
              )}
            </OKCover>
          </div>
        </div>
        <div className="aggregator-view__content grid-view__body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xs-12 col-md-8 col-lg-9">
                {isFetching && !hasBanks ? <LoadingSection /> : children}
              </div>
              <div className="col-xs-12 col-md-4 col-lg-3">
                <div>
                  <AggregatorSidebar
                    total={aggSidebarTotal}
                    productType={productType}
                    values={aggregatorSidebar}
                    flagBasedFeatures={flagBasedFeatures}
                    isTinkAggregator={isTinkAggregator}
                  />
                </div>
                <div className="aggregator-view__commercial-ads">
                  <CommercialAds path="global/entities" type="banner-a" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AggregatorViewClass.propTypes = {
  children: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  productType: PropTypes.string.isRequired,
  immAggregatorData: PropTypes.object.isRequired,
  aggregatorSidebar: PropTypes.object.isRequired,
  aggregatorFinancing: PropTypes.object.isRequired,
  aggregatorSavingAndInvestment: PropTypes.object.isRequired,
  flagBasedFeatures: PropTypes.object,
  isFetching: PropTypes.bool,
  hasBanks: PropTypes.bool,
  getEntitiesData: PropTypes.function,
  getGlobalPositionTink: PropTypes.function,
  aggregatorBanksTink: PropTypes.object,
  aggregatorDataTink: PropTypes.object,
  isTinkAggregator: PropTypes.bool,
};

const AggregatorView = withRouter(connect(
  (state, props) => {
    const isTinkAggregator = state.flagBasedFeatures.get(NOT_ALLOWED_TINK_AGGREGATOR);

    const aggDataTink = state.aggregatorData.toJS().data;

    const aggBanksTink = aggDataTink.banks && Object.values(aggDataTink.banks);

    const hasBanksTink = aggBanksTink && aggDataTink.length > 0;

    const productType = getTypeFromString(props.location.pathname.split('/').reverse()[0]);
    const hasBanks = !isTinkAggregator
      ? state.aggregatorData.getIn(['data', 'banks'])
      : hasBanksTink;
    const aggregatorFinancing = !isTinkAggregator
      ? state.aggregatorData.getIn(['data', 'financing'])
      : aggDataTink && aggDataTink.financing;
    const aggregatorSavingAndInvestment = !isTinkAggregator
      ? state.aggregatorData.getIn(['data', 'savingAndInvestment'])
      : aggDataTink && aggDataTink.savingAndInvestment;
    const isFetching = !isTinkAggregator
      ? state.aggregatorData.get('isFetching')
      : aggDataTink && aggDataTink.isFetching;

    return {
      productType,
      hasBanks,
      immAggregatorData: state.aggregatorData.getIn(['data', 'aggregation']),
      aggregatorDataTink: aggDataTink,
      aggregatorBanksTink: aggBanksTink,
      aggregatorFinancing,
      aggregatorSavingAndInvestment,
      aggregatorSidebar: !isTinkAggregator
        ? getAggregatorBalanceBankByTypeProduct(state, productType)
        : getAggregatorBalanceBankByTypeProductTink(state, productType),
      flagBasedFeatures: state.flagBasedFeatures,
      isFetching,
      isTinkAggregator,
    };
  },
  {
    getEntitiesData,
    getGlobalPositionTink,
  }
)(AggregatorViewClass));

export { AggregatorView };
